import { CallAPI } from "../../apiManager/ApiCall";
import { addSlideFileURL, deleteSlideFileURL } from "../../apiManager/APIConfig";

export const UploadSlide = async (formData) => {
  try {
    const response = await CallAPI({ url: addSlideFileURL, method: "POST", formData });

    // GetTitlesCall(body?.lang, body?.type);
    return response;
  } catch (error) {
    return { status: 400 };
  }
};
export const DeleteFile = async (file_id) => {
  try {
    const response = await CallAPI({
      url: `${deleteSlideFileURL}/${file_id}`,
      method: "DELETE",
    });

    // GetTitlesCall(body?.lang, body?.type);
    return response;
  } catch (error) {
    return { status: 400 };
  }
};
